<template> <ResourcesComponent/></template>
<script>
import ResourcesComponent from "@/components/resources/ResourcesComponent.vue"
export default {
    name: "ResourcesView",
  components:{ResourcesComponent}
};
</script>
